import { render, staticRenderFns } from "./QuotationTaskClose.vue?vue&type=template&id=39da7f9d"
import script from "./QuotationTaskClose.vue?vue&type=script&lang=js"
export * from "./QuotationTaskClose.vue?vue&type=script&lang=js"
import style0 from "./QuotationTaskClose.vue?vue&type=style&index=0&id=39da7f9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports